"use client";
import { useEffect } from "react";
import StaticFooter from "@/components/Footer/StaticFooter";
import Navigation from "@/components/Navigation";
import { createDefaultNavigation } from "@/lib/navigation/defaultNavigation";
import Script from "next/script";
import { useTranslations } from "next-intl";

interface ErrorProps {
  error: Error & { digest?: string };
}

const Error = ({ error }: ErrorProps) => {
  const t = useTranslations("ErrorPages");

  useEffect(() => {
    // Get current path safely
    const currentPath = (() => {
      try {
        return typeof window !== "undefined"
          ? window.location.pathname
          : "unknown";
      } catch {
        return "unknown";
      }
    })();

    // Log to NewRelic on client side
    if (typeof window !== "undefined" && window.newrelic) {
      try {
        window.newrelic.noticeError(error, {
          type: "nextjsError",
          digest: error.digest || "unavailable",
          page: currentPath,
        });
      } catch (e) {
        console.warn("Could not log error to NewRelic:", e);
      }
    }
  }, [error]);

  return (
    <div>
      <Script src="/scripts/newrelic" />
      <Navigation navigation={createDefaultNavigation()} />
      <div className="flex items-center justify-center">
        <div className="m-auto text-center">
          <h1 className="text-lg">{t("serverErrorTitle")}</h1>
          <p className="text-base">{t("serverErrorDescription")}</p>
        </div>
      </div>
      <StaticFooter />
    </div>
  );
};

export default Error;
